import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IssueColumns } from "./columns";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import {
  LocalButton,
  ModifyButton,
  PrintButton,
  UndoButton,
} from "../utility/component/buttons";
import EditableDataGrid from "../utility/component/datagrid/editableDatagrid";
import {
  setAlertWithTitle,
  setIssueStockItem,
  setnumericKeyboardStatus,
  setnumericKeyboardType,
} from "../utility/Redux/modal";
import uniqeId from "uniqid";
import ModNumericKeyboard from "../utility/component/modalNumeric";
import { ItemMasterHelp } from "../help";
import FirstIcodeItem from "./icodeEnterValue";

import { selectToken } from "../utility/Redux/security";
import BarcodeScanner from "../utility/component/barcodeScanner";
import IsCameraAvailval from "../utility/functions/isCameraAvailvl";
import { getItemByAlios, getItemByCode } from "../utility/constant";
import { emptyRowDetails, enterRowWithItemDetails } from "./fun";
import PurchasePDFDetails from "../test";
import OutlinedTextBox from "../utility/component/textInput";
import DebitNoteBillhelp from "../help/debitNoteItemhelp";
import moment from "moment";
import ListDebitNoteHelp from "../help/listDebitHelp";
const Datagrid = ({
  savePurchaseBill,
  setItemMasterStatus,
  handlePrint,
  setIsClearForm,
  delayedFunction,
  partyDetails,
  rows,
  setRows,
  alertTwoButtonModal,
  handlePrint2,
  clearState,
  setAccountMasterHelpStatus,
  inputRef,
  setAlertTwoButtonModal,
}) => {
  const width = useSelector(selectWidth);
  const [debitNoteBillhelpStatus, setDebitNoteBillHelpStatus] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const columns = IssueColumns(width, (p) => {
    if (partyDetails.ACCOUNT_NO) {
      setRowId(p.row.original.id);
      setItemMasterHelpStatus(true);
      setSelectedId(p.row.original.id);
    } else {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Please select account first",
        })
      );
    }
  });
  const [searchText, setSearchText] = useState("");
  const [itemMasterHelpStatus, setItemMasterHelpStatus] = useState(false);
  const [listDebitHelpStatus, setListDebitHelpStatus] = useState(false);
  const [scannerItem, setScannerItem] = useState("");
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const [rowId, setRowId] = useState("");
  const dispatch = useDispatch();
  const [isDeviceHaveCamera, setIsDeviceHaveCamera] = useState(false);
  const [scannerStatus, setScannerStatus] = useState(false);
  const itemRows = rows.filter((row) => row.ICODE && row.ITEMNAME);
  const iTotal = Number(
    itemRows
      .reduce((acc, row) => {
        const amount = Number(row.AMOUNT);
        return acc + (Number.isFinite(amount) ? amount : 0);
      }, 0)
      .toFixed(2)
  );
  const rTotal = rows.reduce((acc, row) => acc + Number(row.RAMOUNT), 0);
  const iQnty_Total = Number(
    itemRows
      .reduce((acc, row) => {
        const quantity = Number(row.QNTY);
        return acc + (Number.isFinite(quantity) ? quantity : 0);
      }, 0)
      .toFixed(3)
  );
  const rQnty_Total = rows.reduce((acc, row) => acc + Number(row.RQNTY), 0);
  const hasFormData =
    Boolean(partyDetails.ACCOUNT_NO || partyDetails.DEBIT_NOTE_NO) ||
    rows.some(
      (row) =>
        row.ICODE ||
        row.ITEMNAME ||
        row.REMARKS ||
        (row.QNTY !== "" && row.QNTY !== null && row.QNTY !== undefined)
    );

  const handleUndo = () => {
    if (!hasFormData) {
      clearState();
      return;
    }

    setAlertTwoButtonModal({
      title: "Discard changes?",
      msg: "All unsaved debit note changes will be cleared.",
      status: true,
      button1: "Discard",
      button2: "Cancel",
      button1Click: () => {
        clearState();
        setAlertTwoButtonModal((current) => ({
          ...current,
          status: false,
        }));
      },
      button2Click: () => {
        setAlertTwoButtonModal((current) => ({
          ...current,
          status: false,
        }));
      },
    });
  };
  const keyDown = (e, currentFieldName, id) => {
    const value = e.target.value;

    if (currentFieldName === "ICODE" && e.code === "F4") {
      if (partyDetails.ACCOUNT_NO) {
        setRowId(id);
        setItemMasterHelpStatus(true);
      } else {
        setAlertTwoButtonModal({
          status: true,
          title: "Alert",
          msg: "Please Select Account First.",
          button1: "ok",

          button1Click: () => {
            setAlertTwoButtonModal({
              ...alertTwoButtonModal,
              status: false,
            });
            setAccountMasterHelpStatus(true);
          },
        });
      }
    } else {
      if (
        (currentFieldName === "ICODE" &&
          e.code === "Enter" &&
          value !== "" &&
          value !== "0") ||
        (e.code === "NumpadEnter" &&
          value !== "" &&
          value !== "0" &&
          currentFieldName === "ICODE")
      ) {
        if (partyDetails.ACCOUNT_NO) {
          if (!isNaN(value)) {
            const v = value.toString().replace(" ", "");
            if (v) {
              const isFilled = rows.find((r) => r.id === id);
              if (!isFilled?.ITEMNAME) {
                if (
                  !rows.find((o) => {
                    if (o.ITEMNAME) {
                      if (
                        Number(o.ICODE) === Number(value) &&
                        o.id !== id
                      ) {
                        return o; // Return the object if condition matches
                      }
                      if (
                        o?.ALIAS_CODE?.toString() === value.toString() &&
                        o.id !== id
                      ) {
                        return o; // Return the object if condition matches
                      }
                    }
                    return false;
                  })
                ) {
                  if (
                    e.code === "Enter" ||
                    e.code === "NumpadEnter" ||
                    e.code === "ArrowRight"
                  ) {
                    const currentFieldIndex = columns.findIndex(
                      (column) => column.field === currentFieldName
                    );
                    const nextEditableField = columns.find(
                      (column, index) =>
                        index > currentFieldIndex && column.editable
                    );
                    if (nextEditableField) {
                      const nearestInput = document.getElementById(
                        id + "-" + nextEditableField.field
                      );
                      setTimeout(() => {
                        if (nearestInput) {
                          nearestInput.focus();
                          nearestInput.select();
                        }
                      }, 2000);
                    }
                  }
                  getItemByCode(prefix, value, token, dispatch, true).then(
                    (codeItem) => {
                      if (!codeItem[0]) {
                        getItemByAlios(
                          prefix,
                          value,
                          token,
                          dispatch,
                          true
                        ).then((aliosItem) => {
                          enterRowWithItemDetails(
                            aliosItem[0],
                            rows,
                            id,
                            dispatch,
                            setRows,
                            setAlertTwoButtonModal,
                            partyDetails
                          );
                        });
                      } else {
                        enterRowWithItemDetails(
                          codeItem[0],
                          rows,
                          id,
                          dispatch,
                          setRows,
                          setAlertTwoButtonModal,
                          partyDetails
                        );
                      }
                    }
                  );
                } else {
                  setAlertTwoButtonModal((o) => {
                    return {
                      ...o,
                      status: true,
                      title: "Alert",
                      msg: "Item already exist",
                      button1: "ok",
                      button1Click: () => {
                        setAlertTwoButtonModal((o) => {
                          return {
                            ...o,
                            status: false,
                          };
                        });
                      },
                    };
                  });
                }
              } else {
                const currentFieldIndex = columns.findIndex(
                  (column) => column.field === currentFieldName
                );
                const nextEditableField = columns.find(
                  (column, index) =>
                    index > currentFieldIndex && column.editable
                );
                if (nextEditableField) {
                  const nearestInput = document.getElementById(
                    id + "-" + nextEditableField.field
                  );
                  if (nearestInput) {
                    nearestInput.focus();
                    nearestInput.select();
                  }
                }
              }
            } else {
              dispatch(
                setAlertWithTitle({
                  title: "Alert",
                  msg: "Please enter Icode to continue",
                })
              );
            }
          } else {
            setRows((r) =>
              r.map((o) => {
                if (o.id === id) {
                  return {
                    ...o,
                    ICODE: "",
                  };
                } else {
                  return o;
                }
              })
            );
            setSearchText(value);
            setRowId(id);
            setItemMasterHelpStatus(true);
          }
        } else {
          setAlertTwoButtonModal({
            status: true,
            title: "Alert",
            msg: "Please Select account First.",
            button1: "ok",

            button1Click: () => {
              setAlertTwoButtonModal({
                ...alertTwoButtonModal,
                status: false,
              });
              setAccountMasterHelpStatus(true);
            },
          });
        }
      } else {
        if (currentFieldName === "ICODE") {
          setAlertTwoButtonModal({
            status: true,
            title: "Alert",
            msg: "Please Enter Item Code First.",
            button1: "ok",

            button1Click: () => {
              setAlertTwoButtonModal({
                ...alertTwoButtonModal,
                status: false,
              });
            },
          });
        } else {
          if (
            e.code === "Enter" ||
            e.code === "NumpadEnter" ||
            e.code === "ArrowRight"
          ) {
            const currentFieldIndex = columns.findIndex(
              (column) => column.field === currentFieldName
            );
            const nextEditableField = columns.find(
              (column, index) => index > currentFieldIndex && column.editable
            );
            if (nextEditableField) {
              const nearestInput = document.getElementById(
                id + "-" + nextEditableField.field
              );
              if (nearestInput) {
                nearestInput.focus();
                nearestInput.select();
              }
            }
          }
        }
      }
    }
  };

  const nextRow = (index) => {
    delayedFunction(rows[index].id);
  };

  const deletRow = (id) => {
    setRows((o) => {
      const list = o.filter((r) => r.id !== id);
      if (list.find((o) => o.ITEMNAME === "")) {
        return list;
      } else {
        return [
          ...list,
          {
            ...emptyRowDetails,
            id: uniqeId(),
          },
        ];
      }
    });
  };
  const CellEdit = ({ id, field, value }) => {
    if (field === "ICODE") {
      const isSameIdExist = rows.filter((row) => row.id === id);
      if (isSameIdExist[0]) {
        setRows((old) =>
          old.map((item) => {
            if (item.id === id && !item.ITEMNAME) {
              return {
                ...item,
                ICODE: value,
              };
            } else {
              return item;
            }
          })
        );
      } else {
        setRows((old) => {
          return [
            ...old,
            {
              ...old[0],
            },
          ];
        });
      }
    }

    if (field === "QNTY" && !/^\d*\.?\d{0,3}$/.test(value)) {
      return;
    }

    if (field === "QNTY" || field === "REMARKS") {
      const updatedRows = rows.map((row) => {
        if (row.id === id) {
          const item = rows.filter((i) => i.id === id);

          const i = FirstIcodeItem(id, partyDetails, {
            ...item[0],
            [field]: value,
          });
          return i;
        }
        return row;
      });

      setRows(updatedRows);
    }
  };

  useEffect(() => {
    IsCameraAvailval()
      .then(() => {
        setIsDeviceHaveCamera(true);
      })
      .catch(() => {
        setIsDeviceHaveCamera(false);
      });
  }, []);

  const windowWidth = useSelector(selectWidth);

  return (
    <div
      style={{
        height: `calc(100% - ${windowWidth > 1440 ? "90px" : "90px"})`,
      }}
      className="  w-auto "
    >
      <div
        style={{
          height: `calc(100% - ${
            windowWidth < 1280
              ? "100px"
              : windowWidth < 1536
              ? "100px"
              : windowWidth < 1800
              ? "100px"
              : "100px"
          })`,
        }}
        className=" min-h-[200px]"
      >
        <EditableDataGrid
          nextRow={nextRow}
          keyDown={keyDown}
          ignoreMinWidth={true}
          tableMinWidth="960px"
          columns={columns}
          data={rows}
          onScannerClick={
            isDeviceHaveCamera
              ? (e) => {
                  setScannerItem(e);
                  setScannerStatus(true);
                }
              : false
          }
          deletRow={deletRow}
          onEditCell={CellEdit}
          firstInputRef={inputRef}
          onCellDoubleClick={(e) => {
            if (e.column.editable && e.column.field !== "EXP_DATE") {
              if (true) {
                dispatch(setnumericKeyboardType(e.column.field));
                dispatch(setnumericKeyboardStatus(true));
                dispatch(
                  setIssueStockItem({
                    title: e.column.field,

                    id: e.row.original.id,
                    value: e.value,
                  })
                );
              } else {
              }
            }
          }}
        />
      </div>

      <div className="mt-[10px] flex">
        <div
          style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
          className="flex w-full bg-white p-3"
        >
          <div className="flex flex-1 justify-end">
            <div
              className={
                "mt-3 grid w-full grid-cols-1 gap-3 sm:grid-cols-2 xl:max-w-[760px] xl:grid-cols-[minmax(160px,1fr),minmax(160px,1fr),auto]"
              }
            >
              <OutlinedTextBox
                type={"number"}
                value={iQnty_Total}
                label={"Total Qnty"}
                readOnly={true}
              />

              <OutlinedTextBox
                type={"number"}
                value={iTotal}
                label={"Total Amount"}
                readOnly={true}
              />

              <div className="flex flex-wrap justify-end gap-2 sm:col-span-2 xl:col-span-1 xl:flex-nowrap">
                {partyDetails.DEBIT_NOTE_NO ? (
                  <ModifyButton onClick={savePurchaseBill} />
                ) : (
                  <LocalButton
                    title={"Save"}
                    bg={"#a8cf45"}
                    width={"140px"}
                    color={"black"}
                    onClick={savePurchaseBill}
                  />
                )}

                <UndoButton onClick={handleUndo} />
                <div>
                  <PrintButton
                    onClick={() => {
                      if (rows.find((o) => o.ICODE && o.ITEMNAME)) {
                        setIsClearForm(false);
                        handlePrint2();
                      } else {
                        dispatch(
                          setAlertWithTitle({
                            title: "Alert",
                            msg: "Nothing found to print",
                          })
                        );
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ItemMasterHelp
        searchText={searchText}
        status={itemMasterHelpStatus}
        onClose={() => {
          setSearchText("");

          setItemMasterHelpStatus(false);
        }}
        onRowClick={(row) => {
          setSearchText("");
          setItemMasterHelpStatus(false);
          const d = {
            id: rowId,
            code: "Enter",
            target: {
              value: row.row.ICODE,
            },
          };
          keyDown(d, "ICODE", d.id);
        }}
      />

      <ModNumericKeyboard
        onChange={(e) => {
          if (e.field === "ICODE") {
            const d = {
              id: e.id,
              code: "Enter",
              target: {
                value: e.value,
              },
            };

            keyDown(d, "ICODE", e.id);
          } else {
            CellEdit(e);
          }
        }}
        editType={""}
        mode={"dark"}
      />
      <BarcodeScanner
        setStatus={setScannerStatus}
        status={scannerStatus}
        onChange={(o) => {
          keyDown(
            { target: { value: o }, code: "Enter" },
            "ICODE",
            scannerItem
          );
        }}
      />
      <DebitNoteBillhelp
        status={debitNoteBillhelpStatus}
        Account_No={partyDetails.ACCOUNT_NO}
        onRowClick={(p) => {
          setDebitNoteBillHelpStatus(false);

          const row = p.row;
          enterRowWithItemDetails(
            row,
            rows,
            selectedId,
            dispatch,
            setRows,
            setAlertTwoButtonModal,
            partyDetails
          );
        }}
        onClose={() => {
          setDebitNoteBillHelpStatus(false);
        }}
      />
    </div>
  );
};

export default Datagrid;
